export const LogoMark = ({ size = 34, dark = false }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill={dark ? "#F2EAE1" : "#181615"} />
    <path d="M12 38a20 20 0 0 1 40 0z" fill="#C85A32" />
    <path d="M12 31h40M14 24.5h36" stroke={dark ? "#F2EAE1" : "#181615"} strokeWidth="3" />
    <path d="M32 42c-3 4-4.5 6.5-4.5 8.5a4.5 4.5 0 0 0 9 0c0-2-1.5-4.5-4.5-8.5z" fill="#E0A030" />
    <path d="M10 38h44" stroke={dark ? "#181615" : "#F2EAE1"} strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false, testId = "nav-logo" }) => (
  <a href="/" data-testid={testId} className="group inline-flex items-center gap-3">
    <span className="transition-transform duration-500 group-hover:rotate-[-8deg]">
      <LogoMark dark={dark} />
    </span>
    <span className={`leading-none ${dark ? "text-[#F2EAE1]" : "text-[#181615]"}`}>
      <span className="font-display block text-[1.15rem] italic tracking-tight">Golden Hour</span>
      <span className="eyebrow block whitespace-nowrap text-[0.58rem] text-[#C85A32]">Press<span className="hidden sm:inline"> · Cold Juicery</span></span>
    </span>
  </a>
);
